/*
 * @Author: Teemo Ding
 * @Date: 2021-07-09 17:27:54
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 16:15:37
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Taxes/TaxEditPage/TaxRate/index.tsx
 */
import { Checkbox, Input, Label, Select } from '@/src/components/Antd';
import NumberInput, {
  EnumMode,
} from '@/src/components/Antd/NumberInput/NumberInput';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import SplitLine from 'src/components/SplitLine/SplitLine';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from '../css.module.less';

// enum List {
//   Inclusive = 'Inclusive',
//   Exclusive = 'Exclusive',
// }
// const inclusiveOption = [
//   { value: List.Inclusive, label: 'Tax Inclusive' },
//   {
//     value: List.Exclusive,
//     label: 'Tax Exclusive',
//   },
// ];

const rateList = [
  {
    value: '',
    label: '%',
  },
];

const TaxRate = ({ availableCurrencies, disabled, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const chargeCurrencyOptions = availableCurrencies.map((item) => ({
    value: item.code,
    label: `${item.code}${
      item.reportingCurrency
        ? `(${getI18n('storeTaxes.taxEditPage.reportingCurrency')})`
        : ''
    }`,
  }));
  const rateOptions = rateList.concat(chargeCurrencyOptions);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClass}
      title={getI18n('storeTaxes.taxListPage.taxRate')}>
      {disabled ? null : (
        <React.Fragment>
          <Row
            elements={[
              {
                child: (
                  <Form.Item
                    name='ruleTitle'
                    labelCol={{
                      span: 24,
                    }}
                    rules={[
                      {
                        required: true,
                        message: replaceI18nVariables(
                          getI18n('general.fieldisrequired'),
                          getI18n('storeTaxes.taxListPage.taxRuleTitle'),
                        ),
                      },
                    ]}
                    label={
                      <Label
                        title={`${getI18n(
                          'storeTaxes.taxListPage.taxRuleTitle',
                        )}*`}
                        rightSubTitle={getI18n(
                          'storeTaxes.taxEditPage.taxRuleSubTitle',
                        )}
                        textLength={100}
                        nameKey='ruleTitle'
                      />
                    }>
                    <Input
                      size='large'
                      maxLength={100}
                      disabled={disableEdit}
                    />
                  </Form.Item>
                ),
              },
              {
                child: null,
              },
              // {
              //   child: (
              //     <Form.Item
              //       name='taxInclusion'
              //       labelCol={{
              //         span: 24,
              //       }}
              //       rules={[
              //         {
              //           required: true,
              //           message: 'Inclusive/Exclusive Is Required.',
              //         },
              //       ]}
              //       label='Inclusive/Exclusive*'>
              //       <Select
              //         size='large'
              //         maxLength={100}
              //         getPopupContainer={(triggerNode) => triggerNode.parentElement}
              //         suffixIcon={<Icon type='icondown' className={css.icon} />}
              //         optionsList={inclusiveOption}
              //       />
              //     </Form.Item>
              //   ),
              // },
            ]}
          />
          <Form.Item noStyle name='compound' valuePropName='checked'>
            <Checkbox className={css.checkboxBox} disabled={disableEdit}>
              <span className={css.checkTitle}>
                {getI18n('storeTaxes.taxListPage.compound')}
              </span>
              <span className={css.checkDescription}>
                {getI18n('storeTaxes.taxEditPage.checkboxDescription')}
              </span>
            </Checkbox>
          </Form.Item>
          <SplitLine className={css.splitLine} />

          <Row
            elements={[
              {
                child: (
                  <Form.Item
                    labelCol={{
                      span: 24,
                    }}
                    className={css.taxRate}
                    label={
                      <Label
                        title={`${getI18n('storeTaxes.taxListPage.taxRate')}*`}
                        textLength={100}
                      />
                    }>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: replaceI18nVariables(
                            getI18n('general.fieldisrequired'),
                            getI18n('storeTaxes.taxListPage.taxRate'),
                          ),
                        },
                      ]}
                      className={css.taxRateInput}
                      name='taxRate'>
                      <NumberInput
                        mode={EnumMode.money}
                        size='large'
                        placeholder='0.00'
                        disabled={disableEdit}
                      />
                    </Form.Item>
                    <Form.Item className={css.rateCurrency} name='rateCurrency'>
                      <Select
                        optionsList={rateOptions}
                        size='large'
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentElement
                        }
                        suffixIcon={
                          <Icon type='icondown' className={css.icon} />
                        }
                        disabled={disableEdit}
                      />
                    </Form.Item>
                  </Form.Item>
                ),
              },
              {
                child: '',
              },
            ]}
          />
          <Form.Item noStyle name='conditionsApplied' valuePropName='checked'>
            <Checkbox className={css.applyCheckboxBox} disabled={disableEdit}>
              {getI18n('storeTaxes.taxEditPage.applywithconditions')}
            </Checkbox>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) =>
              prevValues.conditionsApplied !== curValues.conditionsApplied ||
              prevValues.rateCurrency !== curValues.rateCurrency ||
              prevValues.chargeCurrency !== curValues.chargeCurrency ||
              prevValues.maximum !== curValues.maximum ||
              prevValues.minimum !== curValues.minimum
            }>
            {({ getFieldValue }) =>
              getFieldValue('conditionsApplied') && (
                <Fragment>
                  {!getFieldValue('rateCurrency') && (
                    <Row
                      elements={[
                        {
                          child: (
                            <Form.Item
                              name='chargeCurrency'
                              labelCol={{
                                span: 24,
                              }}
                              label={getI18n(
                                'storeTaxes.taxEditPage.chargeCurrency',
                              )}>
                              <Select
                                optionsList={chargeCurrencyOptions}
                                size='large'
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentElement
                                }
                                suffixIcon={
                                  <Icon type='icondown' className={css.icon} />
                                }
                                disabled={disableEdit}
                              />
                            </Form.Item>
                          ),
                        },
                        {
                          child: '',
                        },
                      ]}
                    />
                  )}
                  <Row
                    elements={[
                      {
                        child: (
                          <Form.Item
                            name='minimum'
                            labelCol={{
                              span: 24,
                            }}
                            rules={[
                              {
                                required: true,
                                message: getI18n('general.fieldCannotEmpty'),
                              },
                              {
                                type: 'number',
                                max: getFieldValue('maximum'),
                                message: getI18n(
                                  'storeTaxes.taxEditPage.validmaximum',
                                ),
                              },
                            ]}
                            label={`${getI18n(
                              'storeTaxes.taxEditPage.minimumOrderAmount',
                            )}* (>=)`}>
                            <NumberInput
                              size='large'
                              suffix={
                                getFieldValue('rateCurrency') ||
                                getFieldValue('chargeCurrency')
                              }
                              disabled={disableEdit}
                            />
                          </Form.Item>
                        ),
                      },
                      {
                        child: (
                          <Form.Item
                            name='maximum'
                            labelCol={{
                              span: 24,
                            }}
                            rules={[
                              {
                                type: 'number',
                                min: getFieldValue('minimum'),
                                message: '',
                              },
                            ]}
                            label={
                              <div className={css.maximumLabel}>
                                <Label
                                  title={`${getI18n(
                                    'storeTaxes.taxEditPage.maximumOrderAmount',
                                  )} (<)`}
                                  rightSubTitle={getI18n(
                                    'storeTaxes.taxEditPage.validminimum',
                                  )}
                                />
                              </div>
                            }>
                            <NumberInput
                              className={css.noLimitInput}
                              size='large'
                              placeholder={getI18n(
                                'storeTaxes.taxEditPage.nolimit',
                              )}
                              suffix={
                                getFieldValue('rateCurrency') ||
                                getFieldValue('chargeCurrency')
                              }
                              disabled={disableEdit}
                            />
                          </Form.Item>
                        ),
                      },
                    ]}
                  />
                </Fragment>
              )
            }
          </Form.Item>
        </React.Fragment>
      )}
    </SectionWrapper>
  );
};

export default TaxRate;
